import useJwt from '@/auth/jwt/useJwt';
import ability from '@/libs/acl/ability';
import { hasExplicitModuleAccess } from '@/libs/acl/routeProtection';
import { isActiveAdminDkp } from '@/libs/acl/activeAdminDkp';

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);
};

export const getUserData = () => JSON.parse(localStorage.getItem('userData'));

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param role
 */
export const getHomeRouteForLoggedInUser = (role, can = (action, subject) => ability.can(action, subject)) => {
  const preferredRoutes = {
    AdminDKP: { name: 'dashboard-admin-dkp', action: 'manage', resource: 'all' },
    Administrador: { name: 'dashboard-executivo', action: 'read', resource: 'AdminHanes' },
    Supervisor: { name: 'pedidos-vendas-aprovacoes', action: 'read', resource: 'PedidosAprovacao' },
    Representante: { name: 'dashboard-equipe-vendas', action: 'read', resource: 'DashboardEquipeVendas' },
    Cliente: { name: 'dashboard-cliente', action: 'read', resource: 'DashboardCliente' },
  };
  const preferred = preferredRoutes[role];
  if (preferred && can(preferred.action, preferred.resource)) return { name: preferred.name };

  // Home também é um módulo removível. Nunca a use como fallback sem a
  // permissão explícita, pois isso reabria o acesso após removê-la da matriz.
  if (hasExplicitModuleAccess('read', 'Home')) return { name: 'home' };
  if (isActiveAdminDkp() && hasExplicitModuleAccess('read', 'AssistenciaTecnica')) {
    return { name: 'assistencia-tecnica' };
  }

  return { name: 'misc-not-authorized' };
};
